import { put, select, takeLatest } from 'redux-saga/effects';
import { ProjectId, TaskId } from 'api/models';
import { TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { updateTaskPrivacyInGanttAction } from 'data/projects/actions';
import { queryClient } from 'queries';
import { getProjectTasksQueryKey } from 'queries/common';
import { updateTaskPrivacySagaAction } from '../actions';
import { selectTask } from '../selectors';
import { saveTasks, updateTaskPrivacy } from '../slice';
function* updateTaskPrivacySaga({ payload }) {
    if (payload) {
        const { taskId, private: isPrivate, projectId, options } = payload;
        const oldTaskState = yield select(selectTask(TaskId(projectId, taskId)));
        if (!(options === null || options === void 0 ? void 0 : options.skipStoreUpdate)) {
            yield put(updateTaskPrivacy(payload));
        }
        try {
            yield TaskAPI.updatePrivacy(taskId, {
                private: isPrivate
            });
            yield put(updateTaskPrivacyInGanttAction({
                taskId,
                private: isPrivate
            }));
        } catch (unused) {
            if (oldTaskState) {
                if (options === null || options === void 0 ? void 0 : options.rejectCallback) {
                    options.rejectCallback(oldTaskState);
                }
                if (!(options === null || options === void 0 ? void 0 : options.skipStoreUpdate)) {
                    yield put(saveTasks({
                        data: [
                            oldTaskState
                        ],
                        fetchStatus: FetchStatus.Loaded
                    }));
                }
                yield put(updateTaskPrivacyInGanttAction({
                    taskId,
                    private: oldTaskState.private
                }));
            }
        }
        yield queryClient.refetchQueries({
            predicate: (query)=>{
                return query.queryHash.includes('task-detail') && (query === null || query === void 0 ? void 0 : query.queryHash.includes(taskId.toString()));
            }
        });
        if (projectId) {
            yield queryClient.refetchQueries(getProjectTasksQueryKey(ProjectId(projectId)));
        }
    }
}
export function* watchUpdateTaskPrivacySaga() {
    yield takeLatest(updateTaskPrivacySagaAction.type, updateTaskPrivacySaga);
}
